/**
 * Prefix generator
 *
 * This function generates a unique prefix key to ensure that the naming remains distinct across the application.
 * Previously, instances of identical labels led to shared values, causing unexpected behavior, even when providing
 * a default value.
 *
 * Sample usage of this was the translation, i.e., t()
 *
 * @param type      the type, ex. lbl = label, txt = input, textarea, etc.
 * @param prefix    (optional)
 * @param value     name of that field
 */
export function prefixKey(value, prefix, type = 'lbl') {
    // If no prefix provided, just add this
    if (!prefix) prefix = 'nimbus';
    return `${type}-${prefix}-${value}`;
}

/**
 *
 * @param count         the number of items
 * @param singular      singular form
 * @param plural        (optional) plural form, if not provided will append 's'
 * @returns {*|string}
 *
 * @example: pluralize(count, 'person', 'people')
 */
export function pluralize(count, singular, plural = null) {
    if (plural === null) plural = singular + 's';
    return count === 1 ? singular : plural;
}

export function capitalize(input, capitalizeAllWords = false) {
    if (typeof input !== 'string' || input.length === 0) {
        return input;
    }

    if (capitalizeAllWords) {
        return input.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    }

    return input.charAt(0).toUpperCase() + input.slice(1);
}

export function safeTrim(string) {
    return String(string ?? '').trim();
}
